import * as React from 'react';
import {
  IPasswordStrengthIndicator,
  getStrengthIndicatrTranslationKey,
  getStrengthIndicatroColor,
  getStrengthIndicatroWidth
} from '@poinz/hooks';
import Paragraph from 'components/text/Paragraph';
import { useTranslation } from 'next-i18next';
import { INDICATOR_COLORS, INDICATOR_TRANSLATION_KEYS } from './PasswordStrengthIndicator.utils';

interface Props {
  strength: IPasswordStrengthIndicator;
}
const PasswordStrengthIndicator: React.FC<Props> = ({ strength }) => {
  const { t } = useTranslation();

  const strengthIndicatorColor = getStrengthIndicatroColor(INDICATOR_COLORS, strength) as string;
  const strengthIndicatorWidth = getStrengthIndicatroWidth(strength);
  const strengthIndicatorTranslationKey = getStrengthIndicatrTranslationKey(
    INDICATOR_TRANSLATION_KEYS,
    strength
  );

  return (
    <>
      <Paragraph className="text-xs text-neutral-900">
        {t('general.form.passwordStrength.placeholder', {
          value: `general.form.passwordStrength.${strengthIndicatorTranslationKey}`
        })}
      </Paragraph>
      <div className="w-full h-1 bg-neutral-50 rounded-button block relative">
        <div
          style={{ width: strengthIndicatorWidth }}
          className={`absolute h-full transition-all max-w-full rounded-button ${strengthIndicatorColor}`}
        />
      </div>
    </>
  );
};

export default PasswordStrengthIndicator;
